const privateRoutes = [
  {
    path: 'pregled-usluga',
    name: 'servicesOverview'
  },
  {
    path: 'upravljanje-nalozima',
    name: 'accountManagement'
  },
  {
    path: 'moj-nalog',
    name: 'userAccount'
  },
  {
    path: 'personalizovana-ponuda',
    name: 'personalizedOffer'
  }
]

export default privateRoutes
